/* ============================================================
   DELIVERY DATE PICKER — drop-in replacement for custom.js
   Keeps: rulesJson, checkDeliveryDate(), product form wiring
   Replaces: Bootstrap datepicker UI, CHECK button flow
   ============================================================ */

/* ---------- rulesJson (unchanged) ---------- */
const rulesJson = [
  {
    postcode: [
      "E1","E2","E3","E4","E5","E6","E7","E8","E9","EC",
      "HA","IG","N1","N2","N3","N4","N5","N6","N7","N8","N9",
      "NW","SE","SW","WC","W1","W2","W3","W4","W5","W6","W7","W8","W9"
    ],
    pincode_type: "LONDON",
    blocked_dates: [],
    rule: [{
      valid_days: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
      cutoff: "18",
      offset_days: 0
    }]
  },
  {
    postcode: [
      "AL","B1","B2","B3","B4","B5","B6","B7","B8","B9","BA","BB","BD","BH","BL","BN",
      "BR","BS","CA","CB","CF","CH","CM","CO","CR","CT","CV","CW","DA","DE","DH","DL",
      "DN","DT","DY","EH","EN","EX","FY","G1","G2","G3","G4","G5","G6","G7","G8","G9",
      "GL","GU","HD","HG","HP","HR","HU","HX","IP","KT","L1","L2","L3","L4","L5","L6",
      "L7","L8","L9","LA","LD","LE","LL","LN","LS","LU","M1","M2","M3","M4","M5","M6",
      "M7","M8","M9","ME","MK","NE","NG","NN","NP","NR","OL","OX","PE","PL","PO","PR",
      "RG","RH","RM","S1","S2","S3","S4","S5","S6","S7","S8","S9","SA","SG","SK","SL",
      "SM","SN","SO","SP","SR","SS","ST","SY","TA","TF","TN","TQ","TR","TS","TW","UB",
      "WA","WD","WF","WN","WR","WS","WV","YO"
    ],
    pincode_type: "REST_OF_UK",
    blocked_dates: [
      "25/12/2023","26/12/2023","27/12/2023","01/01/2024","02/01/2024",
      "29/03/2024","30/03/2024","31/03/2024","01/04/2024","02/04/2024",
      "06/05/2024","07/05/2024","27/05/2024","28/05/2024","26/08/2024","27/08/2024"
    ],
    rule: [
      { valid_days: ["Monday","Tuesday","Wednesday","Thursday","Friday"], cutoff: "17", offset_days: 1 },
      { valid_days: ["Sunday","Saturday"], cutoff: "17", offset_days: 1 }
    ]
  },
  {
    postcode: ["AB","DD","DG","FK","HS","IV","KA","KW","KY","ML","PA","PH","TD","ZE"],
    pincode_type: "REST_OF_UK",
    blocked_dates: [
      "25/12/2023","26/12/2023","27/12/2023","01/01/2024","02/01/2024",
      "29/03/2024","30/03/2024","31/03/2024","01/04/2024","02/04/2024",
      "06/05/2024","07/05/2024","27/05/2024","28/05/2024","26/08/2024","27/08/2024"
    ],
    rule: [
      { valid_days: ["Monday","Tuesday","Wednesday","Thursday","Friday"], cutoff: "17", offset_days: 2 },
      { valid_days: ["Sunday","Saturday"], cutoff: "17", offset_days: 2 }
    ]
  }
];

/* ---------- checkDeliveryDate (unchanged) ---------- */
function checkDeliveryDate(inputPostcode, ukTime, ukDay, ukDate, rulesJson) {
  let ruleFoundFlag = "N";
  let offsetDays = 0;
  let blockedDates = [];

  for (const ruleObj of rulesJson) {
    const postCodes = ruleObj.postcode;
    const cutoffTime = ruleObj.rule[0].cutoff;
    blockedDates = ruleObj.blocked_dates;

    if (postCodes.includes(inputPostcode.toUpperCase())) {
      for (const rule of ruleObj.rule) {
        offsetDays = ukTime < cutoffTime ? rule.offset_days : rule.offset_days + 1;
        ruleFoundFlag = "Y";
        break;
      }
      if (ruleFoundFlag === "Y") break;
    }
  }

  if (ruleFoundFlag === "Y") {
    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + offsetDays);
    return { date: deliveryDate, blockedDates_arr: blockedDates };
  } else {
    return { date: "Invalid postcode. Delivery available in the UK only.", blockedDates_arr: [] };
  }
}

/* ---------- Modal HTML (injected once) ---------- */
function injectModalHTML() {
  if (document.getElementById('fp-delivery-modal')) return;

  const modal = document.createElement('div');
  modal.id = 'fp-delivery-modal';
  modal.innerHTML = `
    <div id="fp-backdrop"></div>
    <div id="fp-panel">

      <div id="fp-header">
        <div id="fp-header-left">
          <div id="fp-eyebrow">Delivery</div>
          <div id="fp-title">When should it arrive?</div>
        </div>
        <button id="fp-close">×</button>
      </div>

      <div id="fp-postcode-row">
        <div id="fp-postcode-wrap">
          <input
            type="text"
            id="fp-postcode-input"
            placeholder="Enter delivery postcode"
            maxlength="8"
            autocomplete="postal-code"
          />
          <span id="fp-postcode-status"></span>
        </div>
        <div id="fp-zone-badge" class="fp-hidden">
          <span id="fp-badge-dot"></span>
          <span id="fp-badge-text"></span>
        </div>
      </div>

      <div id="fp-postcode-error" class="fp-hidden">Postcode not found — please check and try again</div>

      <div id="fp-type-toggle">
        <button id="fp-btn-delivery" class="fp-type-btn fp-active">Delivery</button>
        <button id="fp-btn-collect" class="fp-type-btn">Click & Collect</button>
      </div>

      <div id="fp-delivery-strip" class="fp-strip fp-visible">Order by 6pm for same-day delivery in London · Next-day for rest of UK</div>
      <div id="fp-collect-strip" class="fp-strip fp-hidden">Choose your collection date · store selection at checkout</div>

      <div id="fp-cal-nav">
        <button id="fp-prev-month">‹</button>
        <span id="fp-month-label"></span>
        <button id="fp-next-month">›</button>
      </div>

      <div id="fp-day-labels">
        <span>Su</span><span>Mo</span><span>Tu</span><span>We</span>
        <span>Th</span><span>Fr</span><span>Sa</span>
      </div>

      <div id="fp-cal-grid"></div>

      <div id="fp-footer">
        <div id="fp-cal-hint">Enter your postcode to see available dates</div>
        <button id="fp-confirm-btn" class="fp-hidden"></button>
      </div>

    </div>

    <div id="fp-screen-confirmed" style="display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:#fff;z-index:10002;flex-direction:column;align-items:center;justify-content:center;padding:40px 20px;gap:20px;text-align:center;">
      <div id="fp-confirmed-icon" style="width:72px;height:72px;border-radius:50%;background:#edf7f1;color:#2d6a4f;display:flex;align-items:center;justify-content:center;font-size:28px;box-shadow:0 4px 20px rgba(45,106,79,0.2);">✓</div>
      <div>
        <div style="font-family:'Playfair Display',serif;font-size:26px;color:#1a1a1a;font-weight:700;margin-bottom:12px;">All set!</div>
        <div id="fp-confirmed-detail" style="font-size:14px;color:#777;line-height:1.9;"></div>
      </div>
      <div style="width:100%;max-width:480px;display:flex;flex-direction:column;gap:10px;margin-top:8px;">
        <button id="fp-done-btn" style="width:100%;padding:15px;background:#1a1a1a;color:#fff;border:none;border-radius:11px;font-size:14px;font-weight:700;cursor:pointer;letter-spacing:0.04em;font-family:'DM Sans',sans-serif;">Done</button>
        <button id="fp-change-btn" style="background:none;border:none;color:#bbb;font-size:13px;cursor:pointer;text-decoration:underline;font-family:'DM Sans',sans-serif;">Change</button>
      </div>
    </div>

    <style>
      #fp-delivery-modal { position:fixed; inset:0; z-index:10000; display:none; align-items:flex-end; justify-content:center; font-family:'DM Sans',sans-serif; }
      #fp-delivery-modal.fp-open { display:flex; }
      #fp-backdrop { position:absolute; inset:0; background:rgba(0,0,0,0.5); backdrop-filter:blur(2px); }
      #fp-panel { position:fixed; top:0; left:0; right:0; bottom:0; width:100%; max-width:100%; background:#fff; display:flex; flex-direction:column; overflow:hidden; border-radius:0; box-shadow:none; z-index:10001; }

      #fp-header { display:flex; align-items:flex-start; justify-content:space-between; padding:16px 20px 14px; border-bottom:1px solid #f0f0f0; flex-shrink:0; }
      #fp-eyebrow { font-size:10px; letter-spacing:0.14em; color:#bbb; text-transform:uppercase; margin-bottom:4px; }
      #fp-title { font-family:'Playfair Display',serif; font-size:22px; color:#1a1a1a; font-weight:700; line-height:1.2; }
      #fp-close { width:36px; height:36px; border-radius:50%; border:1px solid #e0e0e0; background:#fff; cursor:pointer; font-size:20px; color:#555; display:flex; align-items:center; justify-content:center; flex-shrink:0; }

      #fp-postcode-row { display:flex; align-items:center; gap:10px; padding:10px 20px 8px; border-bottom:1px solid #f0f0f0; flex-shrink:0; }
      #fp-postcode-wrap { flex:1; position:relative; }
      #fp-postcode-input { width:100%; border:1.5px solid #e0e0e0; border-radius:9px; padding:11px 36px 11px 14px; font-size:15px; color:#1a1a1a; font-family:'DM Sans',sans-serif; outline:none; letter-spacing:0.04em; text-transform:uppercase; transition:border-color 0.15s; }
      #fp-postcode-input::placeholder { text-transform:none; letter-spacing:0; color:#bbb; font-size:13px; }
      #fp-postcode-input:focus { border-color:#1a1a1a; }
      #fp-postcode-input.fp-resolved { border-color:#2d6a4f; }
      #fp-postcode-status { position:absolute; right:11px; top:50%; transform:translateY(-50%); font-size:14px; pointer-events:none; }
      #fp-zone-badge { display:flex; align-items:center; gap:6px; border-radius:20px; padding:6px 12px; border:1px solid; flex-shrink:0; }
      #fp-badge-dot { width:7px; height:7px; border-radius:50%; flex-shrink:0; }
      #fp-badge-text { font-size:11px; font-weight:700; letter-spacing:0.05em; text-transform:uppercase; white-space:nowrap; }

      #fp-postcode-error { padding:6px 20px 0; font-size:12px; color:#ef4444; flex-shrink:0; }

      #fp-type-toggle { display:flex; gap:8px; padding:8px 20px 0; flex-shrink:0; }
      .fp-type-btn { flex:1; padding:10px 8px; border:1.5px solid #e0e0e0; border-radius:9px; background:#fff; cursor:pointer; font-family:'DM Sans',sans-serif; font-size:13px; font-weight:600; color:#aaa; transition:all 0.15s; }
      .fp-type-btn.fp-active { border-color:#1a1a1a; color:#1a1a1a; }

      .fp-strip { padding:6px 20px 0; font-size:13px; color:#1a1a1a; font-weight:700; flex-shrink:0; }

      #fp-cal-nav { padding:10px 20px 8px; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
      #fp-cal-nav button { border:1px solid #e8e8e8; background:#fff; border-radius:10px; width:36px; height:36px; cursor:pointer; font-size:18px; color:#aaa; display:flex; align-items:center; justify-content:center; }
      #fp-month-label { font-family:'Playfair Display',serif; font-weight:700; font-size:16px; color:#1a1a1a; }

      #fp-day-labels { display:grid; grid-template-columns:repeat(7,1fr); padding:0 14px; flex-shrink:0; }
      #fp-day-labels span { text-align:center; font-size:11px; color:#ccc; font-weight:700; letter-spacing:0.05em; padding:2px 0; }

      #fp-cal-grid { padding:2px 14px 0; display:flex; flex-direction:column; gap:2px; flex-shrink:0; }
      .fp-cal-row { display:grid; grid-template-columns:repeat(7,1fr); gap:2px; }
      .fp-cal-cell { aspect-ratio:1; display:flex; flex-direction:column; align-items:center; justify-content:center; border-radius:10px; border:1px solid transparent; transition:all 0.12s; }
      .fp-cal-cell.fp-avail { cursor:pointer; background:#fff; border-color:#e8e8e8; }
      .fp-cal-cell.fp-today { background:white; border-color:#d0d0d0; }
      .fp-cal-cell.fp-selected { background:#1a1a1a; border-color:#1a1a1a; }
      .fp-cal-num { font-size:15px; line-height:1; }
      .fp-cal-lbl { font-size:8px; font-weight:700; letter-spacing:0.03em; margin-top:2px; color:#aaa; }
      .fp-today-lbl { color:#555; }

      #fp-footer { padding:10px 20px 28px; border-top:1px solid #f0f0f0; flex-shrink:0; }

      @media screen and (min-width:750px) {
        #fp-backdrop { display:none; }
        #fp-panel { align-items:center; overflow-y:auto; }
        #fp-header { width:480px; padding-top:48px; }
        #fp-postcode-row { width:480px; }
        #fp-postcode-error { width:480px; }
        #fp-type-toggle { width:480px; }
        .fp-strip { width:480px; }
        #fp-cal-nav { width:480px; }
        #fp-day-labels { width:480px; }
        #fp-cal-grid { width:480px; }
        #fp-footer { width:480px; padding-bottom:48px; }
        #fp-close { position:fixed; top:24px; left:50%; margin-left:260px; }
        #fp-screen-confirmed { position:fixed; top:0; left:0; right:0; bottom:0; z-index:5; }
      }
      #fp-cal-hint { text-align:center; font-size:13px; color:#ccc; padding:10px 0; }
      #fp-confirm-btn { width:100%; padding:14px; background:#2d6a4f; color:#fff; border:none; border-radius:10px; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700; cursor:pointer; letter-spacing:0.04em; }

      .fp-hidden { display:none !important; }
      .fp-visible { display:block; }

      @keyframes fp-spin { to { transform:rotate(360deg); } }
      .fp-spinner { width:13px; height:13px; border:2px solid #e0e0e0; border-top-color:#888; border-radius:50%; animation:fp-spin 0.7s linear infinite; display:inline-block; vertical-align:middle; }
    </style>
  `;

  document.body.appendChild(modal);
}

/* ---------- Picker state ---------- */
const FP = {
  zone: null,
  type: 'delivery',
  postcode: '',
  calYear: null,
  calMonth: null,
  selectedDate: null,
  startDate: null,
  blockedDates: [],
  checkTimer: null,
  MONTHS: ["January","February","March","April","May","June","July","August","September","October","November","December"]
};

/* ---------- Helpers ---------- */
function fpIsValidPC(pc) {
  return /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(pc.trim());
}

async function fpLookupPostcode(pc) {
  const clean = pc.replace(/\s/g,'').toUpperCase();
  const res = await fetch(`https://api.postcodes.io/postcodes/${clean}`);
  if (!res.ok) throw new Error('not found');
  const data = await res.json();
  return data.result;
}

function fpGetStrippedPostcode(pc) {
  const clean = pc.trim().toUpperCase().replace(/\s/g,'');
  return clean.length > 2 ? clean.substring(0, 2) : clean;
}

function fpIsBlocked(date) {
  const dd = String(date.getDate()).padStart(2,'0');
  const mm = String(date.getMonth()+1).padStart(2,'0');
  const yyyy = date.getFullYear();
  return FP.blockedDates.includes(`${dd}/${mm}/${yyyy}`);
}

function fpDateStr(date) {
  const dd = String(date.getDate()).padStart(2,'0');
  const mm = String(date.getMonth()+1).padStart(2,'0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/* ---------- Open / Close ---------- */
function fpOpen() {
  const today = new Date();
  FP.calYear = today.getFullYear();
  FP.calMonth = today.getMonth();
  document.getElementById('fp-delivery-modal').classList.add('fp-open');
  document.body.style.overflow = 'hidden';
  fpRenderCalendar();
  // No autofocus on mobile — prevents keyboard jumping on open
}

function fpClose() {
  const cs = document.getElementById('fp-screen-confirmed');
  if (cs) cs.style.display = 'none';
  document.getElementById('fp-delivery-modal').classList.remove('fp-open');
  document.body.style.overflow = '';
}

/* ---------- Postcode handling ---------- */
function fpClearZone() {
  FP.zone = null;
  FP.startDate = null;
  FP.blockedDates = [];
  FP.selectedDate = null;
  const input = document.getElementById('fp-postcode-input');
  input.classList.remove('fp-resolved');
  document.getElementById('fp-postcode-status').innerHTML = '';
  document.getElementById('fp-zone-badge').classList.add('fp-hidden');
  document.getElementById('fp-confirm-btn').classList.add('fp-hidden');
  document.getElementById('fp-cal-hint').textContent = 'Enter your postcode to see available dates';
  document.getElementById('fp-cal-hint').style.color = '#ccc';
  fpRenderCalendar();
}

function fpApplyZone(pc, result) {
  const stripped = fpGetStrippedPostcode(pc);
  const deliveryResult = checkDeliveryDate(
    stripped,
    new Date().getHours(),
    new Date().toLocaleDateString("en-US", { weekday: "long" }),
    new Date().toLocaleDateString("en-GB"),
    rulesJson
  );

  if (!(deliveryResult.date instanceof Date)) {
    document.getElementById('fp-postcode-status').innerHTML = '&#10007;';
    document.getElementById('fp-postcode-status').style.color = '#ef4444';
    document.getElementById('fp-postcode-error').classList.remove('fp-hidden');
    document.getElementById('fp-postcode-error').textContent = deliveryResult.date;
    return;
  }

  FP.postcode = pc.trim().toUpperCase();
  FP.startDate = deliveryResult.date;
  FP.blockedDates = deliveryResult.blockedDates_arr;

  // Determine zone label from result
  const isLondon = result ? (result.region === 'London' || result.admin_county === 'Greater London') : false;
  FP.zone = isLondon ? 'london' : 'uk';

  const badgeText = isLondon ? 'SAME-DAY' : 'NEXT-DAY';
  const accentColor = '#2d6a4f';
  const accentBg = '#edf7f1';
  const accentBorder = '#b2dfc4';
  const accentTextColor = '#1a7a3e';

  document.getElementById('fp-postcode-input').classList.add('fp-resolved');
  document.getElementById('fp-postcode-status').innerHTML = '&#10003;';
  document.getElementById('fp-postcode-status').style.color = accentColor;

  const badge = document.getElementById('fp-zone-badge');
  badge.classList.remove('fp-hidden');
  badge.style.background = accentBg;
  badge.style.borderColor = accentBorder;
  document.getElementById('fp-badge-dot').style.background = accentColor;
  document.getElementById('fp-badge-text').style.color = accentTextColor;
  document.getElementById('fp-badge-text').textContent = badgeText;

  document.getElementById('fp-postcode-error').classList.add('fp-hidden');
  document.getElementById('fp-cal-hint').textContent = 'Select a date above';
  document.getElementById('fp-cal-hint').style.color = '#ccc';

  fpRenderCalendar();
}

async function fpResolvePostcode(pc) {
  document.getElementById('fp-postcode-status').innerHTML = '<span class="fp-spinner"></span>';
  try {
    const result = await fpLookupPostcode(pc);
    fpApplyZone(pc, result);
  } catch(e) {
    document.getElementById('fp-postcode-status').innerHTML = '&#10007;';
    document.getElementById('fp-postcode-status').style.color = '#ef4444';
    document.getElementById('fp-postcode-error').classList.remove('fp-hidden');
    document.getElementById('fp-postcode-error').textContent = e.message === 'not found'
      ? 'Postcode not found — please check and try again'
      : 'Unable to check postcode — please try again';
  }
}

/* ---------- Type toggle ---------- */
function fpSetType(type) {
  FP.type = type;
  FP.selectedDate = null;
  document.getElementById('fp-btn-delivery').classList.toggle('fp-active', type === 'delivery');
  document.getElementById('fp-btn-collect').classList.toggle('fp-active', type === 'collect');
  document.getElementById('fp-delivery-strip').classList.toggle('fp-hidden', type !== 'delivery');
  document.getElementById('fp-collect-strip').classList.toggle('fp-hidden', type !== 'collect');
  document.getElementById('fp-confirm-btn').classList.add('fp-hidden');
  document.getElementById('fp-cal-hint').style.display = 'block';

  if (type === 'collect' && !FP.zone) {
    FP.zone = '_collect';
  } else if (type === 'delivery' && FP.zone === '_collect') {
    FP.zone = null;
  }

  fpRenderCalendar();
}

/* ---------- Calendar ---------- */
function fpRenderCalendar() {
  const today = new Date();
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const totalDays = new Date(FP.calYear, FP.calMonth + 1, 0).getDate();
  const startDay = new Date(FP.calYear, FP.calMonth, 1).getDay();

  document.getElementById('fp-month-label').textContent = FP.MONTHS[FP.calMonth] + ' ' + FP.calYear;

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= totalDays; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const grid = document.getElementById('fp-cal-grid');
  grid.innerHTML = '';

  for (let row = 0; row < cells.length / 7; row++) {
    const rowEl = document.createElement('div');
    rowEl.className = 'fp-cal-row';

    for (let col = 0; col < 7; col++) {
      const day = cells[row * 7 + col];
      const cell = document.createElement('div');
      cell.className = 'fp-cal-cell';

      if (!day) { rowEl.appendChild(cell); continue; }

      const date = new Date(FP.calYear, FP.calMonth, day);
      const isBlocked = fpIsBlocked(date);
      const isToday = day === today.getDate() && FP.calMonth === today.getMonth() && FP.calYear === today.getFullYear();
      const isTmw = (() => { const tm = new Date(today); tm.setDate(tm.getDate()+1); return day === tm.getDate() && FP.calMonth === tm.getMonth() && FP.calYear === tm.getFullYear(); })();
      const isSel = FP.selectedDate && FP.selectedDate.getDate() === day && FP.selectedDate.getMonth() === FP.calMonth && FP.selectedDate.getFullYear() === FP.calYear;

      // Availability logic
      let avail = false;
      if (FP.type === 'collect') {
        const tomorrow = new Date(t); tomorrow.setDate(tomorrow.getDate() + 1);
        avail = date >= tomorrow;
      } else if (FP.zone && FP.startDate) {
        const startDay = new Date(FP.startDate.getFullYear(), FP.startDate.getMonth(), FP.startDate.getDate());
        avail = date >= startDay && !isBlocked;
      }

      if (isSel) {
        cell.classList.add('fp-selected');
      } else if (isToday && avail) {
        cell.classList.add('fp-avail', 'fp-today');
      } else if (avail) {
        cell.classList.add('fp-avail');
      }

      const num = document.createElement('span');
      num.className = 'fp-cal-num';
      num.style.fontWeight = isSel || (isToday && avail) ? '700' : avail ? '500' : '400';
      num.style.color = isSel ? '#fff' : avail ? '#1a1a1a' : '#ddd';
      num.textContent = day;
      cell.appendChild(num);

      if ((isToday || isTmw) && avail && !isSel) {
        const lbl = document.createElement('span');
        lbl.className = 'fp-cal-lbl' + (isToday ? ' fp-today-lbl' : '');
        lbl.textContent = isToday ? 'TODAY' : 'TMW';
        cell.appendChild(lbl);
      }

      if (avail) {
        cell.addEventListener('click', () => fpSelectDay(day));
      }

      rowEl.appendChild(cell);
    }
    grid.appendChild(rowEl);
  }
}

function fpSelectDay(day) {
  FP.selectedDate = new Date(FP.calYear, FP.calMonth, day);
  fpRenderCalendar();

  const label = FP.selectedDate.toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' });
  const prefix = FP.type === 'collect' ? 'Collect on' : 'Deliver on';
  const btn = document.getElementById('fp-confirm-btn');
  btn.textContent = prefix + ' ' + label;
  btn.classList.remove('fp-hidden');
  document.getElementById('fp-cal-hint').style.display = 'none';
}

function fpConfirm() {
  if (!FP.selectedDate) return;

  // Write date to the hidden datepicker input — keeps existing form wiring intact
  const dateStr = fpDateStr(FP.selectedDate);
  const hiddenInput = document.getElementById('datepicker');
  if (hiddenInput) {
    hiddenInput.value = dateStr;
    // Trigger change event so any existing listeners fire
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Store type as line item property
  const typeInput = document.querySelector('input[name="properties[Delivery Type]"]');
  if (typeInput) typeInput.value = FP.type === 'collect' ? 'Click & Collect' : 'Delivery';

  // Enable add to cart
  document.querySelector('.product-form__submit')?.classList.remove('disabled');
  document.querySelector('.kqsiVA9Jf8LJAbxw8Bau')?.classList.remove('disabled');

  // Update the choose date button label
  const btn = document.getElementById('chooseDeliveryDateBtn-new');
  if (btn) {
    const span = btn.querySelector('.choose-d');
    if (span) span.textContent = (FP.type === 'collect' ? 'Collect: ' : 'Delivery: ') + FP.selectedDate.toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' });
  }

  // Show confirmed screen
  const type = FP.type === 'collect' ? 'Click & Collect' : FP.zone === 'london' ? 'Same-day delivery' : 'Next-day delivery';
  const dateLabel = FP.selectedDate.toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' });
  const accentColor = '#2d6a4f';
  const accentBg = '#edf7f1';

  const icon = document.getElementById('fp-confirmed-icon');
  const detail = document.getElementById('fp-confirmed-detail');

  if (icon) {
    icon.style.background = accentBg;
    icon.style.color = accentColor;
    icon.style.boxShadow = '0 4px 20px rgba(45,106,79,0.2)';
  }
  if (detail) {
    const collectNote = FP.type === 'collect' ? '<br><span style="font-size:11px;color:#bbb">Store selection at checkout</span>' : '';
    detail.innerHTML = '<strong style="color:#333;font-size:15px">' + type + '</strong><br><span style="font-weight:700;color:' + accentColor + ';font-size:16px">' + dateLabel + '</span>' + collectNote;
  }

  const confirmedScreen = document.getElementById('fp-screen-confirmed');
  if (confirmedScreen) confirmedScreen.style.display = 'flex';
}

/* ---------- Month navigation ---------- */
function fpChangeMonth(dir) {
  FP.calMonth += dir;
  if (FP.calMonth > 11) { FP.calMonth = 0; FP.calYear++; }
  if (FP.calMonth < 0)  { FP.calMonth = 11; FP.calYear--; }
  FP.selectedDate = null;
  document.getElementById('fp-confirm-btn').classList.add('fp-hidden');
  document.getElementById('fp-cal-hint').style.display = 'block';
  fpRenderCalendar();
}

/* ---------- Touch swipe on calendar ---------- */
function fpAddSwipe() {
  const grid = document.getElementById('fp-cal-grid');
  if (!grid) return;
  let startX = null;

  grid.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  grid.addEventListener('touchend', function(e) {
    if (startX === null) return;
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      fpChangeMonth(diff > 0 ? 1 : -1);
    }
    startX = null;
  }, { passive: true });
}

/* ---------- Init ---------- */
function fpInit() {
  injectModalHTML();

  const today = new Date();
  FP.calYear = today.getFullYear();
  FP.calMonth = today.getMonth();

  // Open modal button
  const openBtn = document.getElementById('chooseDeliveryDateBtn-new');
  if (openBtn) {
    openBtn.addEventListener('click', fpOpen);
  }

  // Close button + backdrop
  document.addEventListener('click', function(e) {
    if (e.target.id === 'fp-close' || e.target.id === 'fp-backdrop') fpClose();
    if (e.target.id === 'fp-done-btn') fpClose();
    if (e.target.id === 'fp-change-btn') {
      const cs = document.getElementById('fp-screen-confirmed');
      if (cs) cs.style.display = 'none';
    }
  });

  // Confirm
  document.addEventListener('click', function(e) {
    if (e.target.id === 'fp-confirm-btn') fpConfirm();
  });

  // Type toggle
  document.addEventListener('click', function(e) {
    if (e.target.id === 'fp-btn-delivery') fpSetType('delivery');
    if (e.target.id === 'fp-btn-collect') fpSetType('collect');
  });

  // Month nav
  document.addEventListener('click', function(e) {
    if (e.target.id === 'fp-prev-month') fpChangeMonth(-1);
    if (e.target.id === 'fp-next-month') fpChangeMonth(1);
  });

  // Postcode input
  document.addEventListener('input', function(e) {
    if (e.target.id !== 'fp-postcode-input') return;
    const val = e.target.value.trim();
    clearTimeout(FP.checkTimer);
    document.getElementById('fp-postcode-error').classList.add('fp-hidden');
    document.getElementById('fp-postcode-status').innerHTML = '';
    document.getElementById('fp-cal-hint').style.color = '#ccc';

    if (!val) { fpClearZone(); return; }

    if (fpIsValidPC(val)) {
      document.getElementById('fp-postcode-status').innerHTML = '<span class="fp-spinner"></span>';
      FP.checkTimer = setTimeout(() => fpResolvePostcode(val), 350);
    } else {
      if (FP.zone) fpClearZone();
      if (val.length >= 5) {
        FP.checkTimer = setTimeout(() => {
          if (!fpIsValidPC(document.getElementById('fp-postcode-input').value.trim())) {
            document.getElementById('fp-postcode-error').classList.remove('fp-hidden');
            document.getElementById('fp-postcode-error').textContent = 'Please enter a valid UK postcode e.g. SW3 2BF';
          }
        }, 800);
      }
    }
  });

  document.addEventListener('blur', function(e) {
    if (e.target.id !== 'fp-postcode-input') return;
    const val = e.target.value.trim();
    if (val && !fpIsValidPC(val) && !FP.zone) {
      document.getElementById('fp-postcode-error').classList.remove('fp-hidden');
      document.getElementById('fp-postcode-error').textContent = 'Please enter a valid UK postcode e.g. SW3 2BF';
    }
  }, true);

  // Add swipe support
  fpAddSwipe();

  // Disable submit on page load until date picked
// document.querySelector('.product-form__submit')?.classList.add('disabled');
  document.querySelector('.kqsiVA9Jf8LJAbxw8Bau')?.classList.add('disabled');
}

/* ---------- Boot ---------- */
function fpBoot() {
  // Try immediately
  if (document.getElementById('chooseDeliveryDateBtn-new')) {
    fpInit();
    return;
  }
  // Button not in DOM yet — wait for it
  const observer = new MutationObserver(function() {
    if (document.getElementById('chooseDeliveryDateBtn-new')) {
      observer.disconnect();
      fpInit();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fpBoot);
} else {
  fpBoot();
}

/* ============================================================
   Variant Button Price Injection
   Reads from inline variant JSON already on the page
   ============================================================ */
(function() {
  function initVariantPrices() {
    // Read prices from inline JSON in variant-radios script tag
    const scriptTag = document.querySelector('variant-radios script[type="application/json"]');
    if (!scriptTag) return;

    let variants;
    try { variants = JSON.parse(scriptTag.textContent); } catch(e) { return; }

    const priceMap = {};
    variants.forEach(v => {
      if (!priceMap[v.option1]) {
        priceMap[v.option1] = { price: v.price, available: v.available };
      }
    });

    // Target only the size option box labels
    document.querySelectorAll('#option-box-ymq-variant-0 .ymq-options-button-label').forEach(label => {
      const valueEl = label.querySelector('.ymq-option-value');
      if (!valueEl) return;
      const data = priceMap[valueEl.textContent.trim()];
      if (!data) return;

      let priceSpan = label.querySelector('.fp-variant-price');
      if (!priceSpan) {
        priceSpan = document.createElement('span');
        priceSpan.className = 'fp-variant-price';
        label.appendChild(priceSpan);
      }
      priceSpan.textContent = '£' + parseFloat((data.price / 100).toFixed(2));

      if (!data.available) label.classList.add('fp-variant-unavailable');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initVariantPrices, 600));
  } else {
    setTimeout(initVariantPrices, 600);
  }
})();
